import { render, staticRenderFns } from "./simple_mobile.vue?vue&type=template&id=2ab5b9e4&scoped=true&"
import script from "./simple_mobile.vue?vue&type=script&lang=js&"
export * from "./simple_mobile.vue?vue&type=script&lang=js&"
import style0 from "./simple_mobile.vue?vue&type=style&index=0&id=2ab5b9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5b9e4",
  null
  
)

export default component.exports